module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n1r3r6n-c377d3323895b4950134aed800aa0e25.svg";